import { resolveSpacingArg } from './computeSpacingArg';

import { Spacing, SpacingArg } from '../types';

export function makeSpacing(spacingUnit: number): Spacing {
  return (arg: SpacingArg) => resolveSpacingArg(arg, spacingUnit) as number;
}
